import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BaseTableColumn } from 'src/app/shared/models/app-models/BaseTableColumn.model';

@Component({
  selector: 'app-read-only-table',
  templateUrl: './read-only-table.component.html',
  styleUrls: ['./read-only-table.component.scss']
})
export class ReadOnlyTableComponent<T> implements OnChanges {
  @Input() data!: T[];
  @Input() columns: BaseTableColumn<T>[] = [];
  @Input() noDataMessage: string = "You have no records available.";
  @Input() paginatorRequired: boolean = true
  dataSource: MatTableDataSource<T> = new MatTableDataSource<T>();
  displayedColumns: string[] = []

  ngOnInit() {
    this.displayedColumns = this.columns.map(c => c.columnDef);
    this.dataSource = new MatTableDataSource<T>(this.data);
  }

  isString(value: any) {
    const htmlRegex = /<([a-z]+)(?![^>]*\/>)[^>]*>/
    const isHTML = htmlRegex.test(value)
    return (!isHTML)
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'].currentValue) {
      this.dataSource = new MatTableDataSource<T>(changes['data'].currentValue);
    }
  }
}
